import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default {
  useState : React.useState,
  useRef : React.useRef,
  useHistory,
  useTranslation
}